import GestionTesoreriaModulo from "./GestionTesoreriaModulo";

export default GestionTesoreriaModulo;
